module.exports = __webpack_public_path__ + "img/target.5ac064ad.svg";